import { StructuredData } from './StructuredData';

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Security - Beatview",
  "url": "https://beatview.ai/security",
  "description": "Discover how Beatview protects your recruitment data with enterprise-grade security practices and comprehensive data protection measures.",
  "mainEntity": {
    "@type": "Organization",
    "name": "Beatview",
    "url": "https://beatview.ai"
  },
  "about": {
    "@type": "Thing",
    "name": "Enterprise Security",
    "description": "SOC 2 Type II aligned, GDPR aligned, CCPA aligned security practices for recruitment data protection"
  },
  "specialty": [
    "Data Encryption (AES-256, TLS 1.3)",
    "Access Controls (RBAC, MFA)",
    "Infrastructure Security",
    "Compliance (SOC 2, GDPR, CCPA)",
    "Incident Response"
  ]
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://beatview.ai"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Security",
      "item": "https://beatview.ai/security"
    }
  ]
};

export function SecurityStructuredData() {
  return <StructuredData data={[webPageSchema, breadcrumbSchema]} />;
}
